<lib-program-discovery
  [dateFormat]="dateFormat"
  [momentDateFormat]="momentDateFormat"
  [iCurrencyMask]="iCurrencyMask"
  [programDiscoveryTitle]="programDiscoveryTitle"
  [searchHelpText]="searchHelpText"
  [showProgramTypeFilter]="showprogramtypefilter"
  [search]="search">
</lib-program-discovery>